module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/coat-hook/wood.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/coat-hook/wood.jpg
// module id = 541
// module chunks = 0